const defaultProps = {
  startColor: `gray.200`,
  endColor: `gray.300`,
}

export default {
  defaultProps,
}
